import { render } from "./Kontakt.vue?vue&type=template&id=23dbd896&ts=true"
import script from "./Kontakt.vue?vue&type=script&lang=ts"
export * from "./Kontakt.vue?vue&type=script&lang=ts"

import exportComponent from "/workspace/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__